import { render, staticRenderFns } from "./XcqThreeImg.vue?vue&type=template&id=b24f525a&scoped=true&"
import script from "./XcqThreeImg.vue?vue&type=script&lang=ts&"
export * from "./XcqThreeImg.vue?vue&type=script&lang=ts&"
import style0 from "./XcqThreeImg.vue?vue&type=style&index=0&id=b24f525a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24f525a",
  null
  
)

export default component.exports